import { pointsFormatter } from "../../helpers";
import { utilities } from "../../styles";
import styles from "./PlayerRankTotalPointsComponent.module.css";

function PlayerRankTotalPointsComponent(props: {
  globalRank: number;
  totalPoints: number;
  style?: React.CSSProperties;
}) {
  // TODO: Get player info via provider
  const { globalRank, totalPoints, style } = props;
  return (
    <div
      className={`${styles["player-info"]} ${utilities["flex-center"]}`}
      style={style}
    >
      <div
        className={`${utilities["flex-row"]} ${utilities["width-100"]} ${utilities["space-between"]} ${utilities["flex-gap"]}`}
      >
        <div className={styles["points"]}>
          Total Points: {pointsFormatter(totalPoints)}
        </div>
      </div>
      {globalRank > 0 && (
        <div
          className={`${utilities["flex-row"]} ${utilities["width-100"]} ${utilities["space-between"]} ${utilities["flex-gap"]}`}
        >
          <div className={styles["rank"]}>Global Rank: {globalRank}</div>
        </div>
      )}
    </div>
  );
}

export default PlayerRankTotalPointsComponent;
